var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-profile text-center"},[_c('div',{staticClass:"cimg"},[_c('img',{attrs:{"src":_vm.profile.info 
                && _vm.profile.info.profile_image 
                ? _vm.profile.info.profile_image  : '',"alt":""}})]),_c('div',{staticClass:"name text-center p-3"},[_c('router-link',{attrs:{"to":"/my-page"}},[_c('h5',[_vm._v(_vm._s(_vm.profile.info ? _vm.profile.info.name : 'no nickname'))])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }